import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CommonSelect from "../../../core/common/commonSelect";
import { InputOtp } from "primereact/inputotp";

import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import CircleProgressSmall from "./circleProgressSmall";
import "./verification.css"

const Profile = () => {
  const route = all_routes;
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [showOtpInput2, setShowOtpInput2] = useState(false);
  const [token, setTokens] = useState<any>();
  // const [permanentAddress, setPermanentAddress] = useState({
  //   address: "",
  //   tehsil: "",
  //   district: "",
  //   state: "",
  //   pincode: "",
  //   country: "",
  // });

  // const [isChecked, setIsChecked] = useState(false);

  // // Function to copy current address to permanent address
  // const handleCheckboxChange = (e) => {
  //   setIsChecked(e.target.checked);
  //   if (e.target.checked) {
  //     setPermanentAddress(""); // Copy current address values
  //   } else {
  //     setPermanentAddress({ // Reset when unchecked
  //       address: "",
  //       tehsil: "",
  //       district: "",
  //       state: "",
  //       pincode: "",
  //       country: "",
  //     });
  //   }
  // };

  // // Handle manual input change
  // const handleChange = (e) => {
  //   setPermanentAddress({ ...permanentAddress, [e.target.name]: e.target.value });
  // };

  const handleSendOtp = () => {
    
      setShowOtpInput(true);
      // Simulate sending OTP (You can integrate API call here)
 
  };
  const handleSendOtp2 = () => {
    
    setShowOtpInput2(true);
    // Simulate sending OTP (You can integrate API call here)

};
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Profile </h2>
           
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="card">
            <div className="card-body">
              {/* Candidate Details */}
              <div>
                {/* <div>
                  <h4 className="d-flex align-items-center">My Profile</h4>
                </div> */}
                <div className="offcanvas-body">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex align-items-center flex-wrap flex-md-nowrap row-gap-3">
                        <span className="avatar avatar-xxxl candidate-img flex-shrink-0 me-3">
                          <ImageWithBasePath
                            src="assets/img/users/user-03.jpg"
                            alt="Img"
                            className="rounded-circle"
                          />
                          <div className="profile-upload">
                            <div className="profile-uploader ">
                              <div className="drag-upload-btn btn btn-sm btn-icon btn-outline-primary rounded-full ">
                                <i className="ti ti-edit" />
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  multiple
                                />
                              </div>
                            </div>
                          </div>
                        </span>
                        <div className="flex-fill border rounded p-3 pb-0">
                          <div className="row align-items-center">
                            <div className="col-md-3">
                              <div className="mb-3">
                                <p className="mb-1">User Name</p>
                                <h6 className="fw-normal">Accountant</h6>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="mb-3">
                                <p className="mb-1">Registration Type</p>
                                <h6 className="fw-normal">Accountant</h6>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="mb-3">
                                <p className="mb-1">Applicant Type</p>
                                <h6 className="fw-normal">
                                  harold@example.com
                                </h6>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="mb-3">
                                <p className="mb-1">Registration Date</p>
                                <h6 className="fw-normal">12 Sep 2024</h6>
                              </div>
                            </div>
                         
                            <div className="col-md-3">
                              <div className="mb-3">
                                <p className="mb-1">Applied in APMC</p>
                                <h6 className="fw-normal">
                                  harold@example.com
                                </h6>
                              </div>
                            </div>
                         
                            <div className="col-md-3">
                              <div className="mb-3 d-flex justify-content-between">
                                <p className="mb-1">Profile Score</p>
                                {/* <CircleProgress value={65} /> */}
                                <CircleProgressSmall value={86} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="contact-grids-tab p-0 mb-3">
                    <ul className="nav nav-underline" id="myTab" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active pt-0"
                          id="info-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#basic-info"
                          type="button"
                          role="tab"
                          aria-selected="true"
                        >
                          Personal Info
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link pt-0"
                          id="address-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#address"
                          type="button"
                          role="tab"
                          aria-selected="false"
                        >
                          Firm Info
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link pt-0"
                          id="address-tab2"
                          data-bs-toggle="tab"
                          data-bs-target="#address2"
                          type="button"
                          role="tab"
                          aria-selected="false"
                        >
                          Address
                        </button>
                      </li>
                      {/* <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link pt-0"
                                    id="address-tab3"
                                    data-bs-toggle="tab"
                                    data-bs-target="#address3"
                                    type="button"
                                    role="tab"
                                    aria-selected="false"
                                >
                                   Bank Information
                                </button>
                            </li> */}
                    </ul>
                  </div>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="basic-info"
                      role="tabpanel"
                      aria-labelledby="info-tab"
                      tabIndex={0}
                    >
                      <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between">
                          <h5>Personal Details</h5>
                          <Link
                            to="#"
                            className="btn btn-sm btn-info "
                            data-bs-toggle="modal"
                            data-inert={true}
                            data-bs-target="#personal_info"
                          >
                            Edit
                          </Link>
                        </div>
                        <div className="card-body pb-0">
                          <div className="row align-items-center">
                            <div className="col-md-4">
                              <div className="mb-3">
                                <p className="mb-1">Applicant Name</p>
                                <h6 className="fw-normal">
                                  harold@example.com
                                </h6>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <p className="mb-1">
                                  Moblie No{" "}
                                  <Link
                                    to="#"
                                    className="btn btn-icon btn-sm"
                                    data-bs-toggle="modal"
                                    data-inert={true}
                                    data-bs-target="#mobile_edit"
                                  >
                                    <i className="ti ti-edit" />
                                  </Link>
                                </p>
                                <h6 className="fw-normal">Indian</h6>
                              </div>
                            </div>
                        
                            <div className="col-md-4">
                              <div className="mb-3">
                                <p className="mb-1">
                                  Email{" "}
                                  <Link
                                    to="#"
                                    className="btn btn-icon btn-sm"
                                    data-bs-toggle="modal"
                                    data-inert={true}
                                    data-bs-target="#email_edit"
                                  >
                                    <i className="ti ti-edit" />
                                  </Link>
                                </p>
                                <h6 className="fw-normal">Christianity</h6>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="mb-3">
                                <p className="mb-1 d-flex">Pan Card No</p>
                                <h6 className="fw-normal">Christianity</h6>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <p className="mb-1 d-flex ">Election card No</p>
                                <h6 className="fw-normal">Christianity</h6>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <p className="mb-1 d-flex">
                                  Applicant Signature
                                </p>
                                <h6 className="fw-normal">
                                  {" "}
                                  <Link
                                    to="#"
                                    className="avatar avatar-sm avatar-rounded me-2"
                                  >
                                    <ImageWithBasePath
                                      src="assets/img/users/user-01.jpg"
                                      alt="Img"
                                    />
                                  </Link>
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <div className="card">
                                <div className="card-header">
                                    <h5>Resume</h5>
                                </div>
                                <div className="card-body pb-0">
                                    <div className="row align-items-center">
                                        <div className="col-md-6">
                                            <div className="d-flex align-items-center mb-3">
                                                <span className="avatar avatar-lg bg-light-500 border text-dark me-2">
                                                    <i className="ti ti-file-description fs-24" />
                                                </span>
                                                <div>
                                                    <h6 className="fw-medium">Resume.doc</h6>
                                                    <span>120 KB</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3 text-md-end">
                                                <Link
                                                    to="#"
                                                    className="btn btn-dark d-inline-flex align-items-center"
                                                >
                                                    <i className="ti ti-download me-1" />
                                                    Download
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                    </div>
                    <div
                      className="tab-pane fade"
                      id="address"
                      role="tabpanel"
                      aria-labelledby="address-tab"
                      tabIndex={0}
                    >
                      <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between">
                          <h5>Firm/Co-operative Society Information- </h5>
                          <Link
                            to="#"
                            className="btn  btn-info btn-sm"
                            data-bs-toggle="modal"
                            data-inert={true}
                            data-bs-target="#firm_info"
                          >
                         Edit
                          </Link>
                        </div>
                        <div className="card-body pb-0">
                          <div className="row align-items-center">
                            <div className="col-md-12">
                              <div className="mb-3">
                                <p className="mb-1">
                                  Firm/Co-Operative Society/Company Name
                                </p>
                                <h6 className="fw-normal">
                                  harold@example.com
                                </h6>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="mb-3">
                                <p className="mb-1">
                                  Registration No. (If the applicant is a
                                  Co-operative Society, Firm, Company, or other
                                  entity.)
                                </p>
                                <h6 className="fw-normal">
                                  harold@example.com
                                </h6>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="mb-3">
                                <p className="mb-1">
                                  GST No. (If the applicant is a Co-operative
                                  Society, Firm, Company, or other entity.){" "}
                                </p>
                                <h6 className="fw-normal">Indian</h6>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="mb-3">
                                <p className="mb-1">
                                  Firm PAN No. (If the applicant is a
                                  Co-operative Society, Firm, Company, or other
                                  entity.)
                                </p>
                                <h6 className="fw-normal">Christianity</h6>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="mb-3">
                                <p className="mb-1">
                                  FPO (Farmer Producer Organization) Certificate
                                  (if applicable)
                                </p>
                                <h6 className="fw-normal">Christianity</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="address2"
                      role="tabpanel"
                      aria-labelledby="address-tab2"
                      tabIndex={0}
                    >
                      <div className="tab-content custom-accordion-items">
                        <div
                          className="tab-pane active show"
                          id="bottom-justified-tab1"
                          role="tabpanel"
                        >
                          <div
                            className="accordion accordions-items-seperate"
                            id="accordionExample"
                          >
                            <div className="accordion-item">
                              <div className="accordion-header" id="headingOne">
                                <div className="accordion-button">
                                  <div className="d-flex align-items-center justify-content-between flex-fill">
                                    <h5>Current Address</h5>
                                    <div className="d-flex">
                                      <Link
                                        to="#"
                                        className="btn btn-icon btn-sm"
                                        data-bs-toggle="modal"
                                        data-inert={true}
                                        data-bs-target="#current_address"
                                      >
                                        <i className="ti ti-edit" />
                                      </Link>
                                      <Link
                                        to="#"
                                        className="d-flex align-items-center collapsed collapse-arrow"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#primaryBorderOne"
                                        aria-expanded="false"
                                        aria-controls="primaryBorderOne"
                                      >
                                        <i className="ti ti-chevron-down fs-18" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                id="primaryBorderOne"
                                className="accordion-collapse collapse border-top"
                                aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <div className="row">
                                    <div className="col-md-4 mb-4">
                                      <span className="d-inline-flex align-items-center">
                                        Address
                                      </span>
                                      <h6 className=" align-items-center fw-medium mt-1">
                                        Hendry Peralt
                                      </h6>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                      <span className="d-inline-flex align-items-center">
                                        Post
                                      </span>
                                      <h6 className=" align-items-center fw-medium mt-1">
                                        Brother
                                      </h6>
                                    </div>
                                    <div className="col-md-4">
                                      <span className="d-inline-flex align-items-center">
                                       Taluka
                                      </span>
                                      <h6 className=" align-items-center fw-medium mt-1">
                                        25 May 2014
                                      </h6>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                      <span className="d-inline-flex align-items-center">
                                        District
                                      </span>
                                      <h6 className=" align-items-center fw-medium mt-1">
                                        25 May 2014
                                      </h6>
                                    </div>
                                 
                              
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="accordion-item">
                              <div className="accordion-header" id="headingTwo">
                                <div className="accordion-button">
                                  <div className="d-flex align-items-center justify-content-between flex-fill">
                                    <h5>Permanent Address</h5>
                                    <div className="d-flex">
                                      <Link
                                        to="#"
                                        className="btn btn-icon btn-sm"
                                        data-bs-toggle="modal"
                                        data-inert={true}
                                        data-bs-target="#permanent_address"
                                      >
                                        <i className="ti ti-edit" />
                                      </Link>
                                      <Link
                                        to="#"
                                        className="d-flex align-items-center collapsed collapse-arrow"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#primaryBorderTwo"
                                        aria-expanded="false"
                                        aria-controls="primaryBorderTwo"
                                      >
                                        <i className="ti ti-chevron-down fs-18" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                id="primaryBorderTwo"
                                className="accordion-collapse collapse border-top"
                                aria-labelledby="headingTwo"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <div className="row">
                                    <div className="col-md-4 mb-4">
                                      <span className="d-inline-flex align-items-center">
                                        Address
                                      </span>
                                      <h6 className=" align-items-center fw-medium mt-1">
                                        Hendry Peralt
                                      </h6>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                      <span className="d-inline-flex align-items-center">
                                        Post
                                      </span>
                                      <h6 className=" align-items-center fw-medium mt-1">
                                        Brother
                                      </h6>
                                    </div>
                                    <div className="col-md-4">
                                      <span className="d-inline-flex align-items-center">
                                       Taluka
                                      </span>
                                      <h6 className=" align-items-center fw-medium mt-1">
                                        25 May 2014
                                      </h6>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                      <span className="d-inline-flex align-items-center">
                                        District
                                      </span>
                                      <h6 className=" align-items-center fw-medium mt-1">
                                        25 May 2014
                                      </h6>
                                    </div>
                                 
                              
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="accordion-item">
                              <div
                                className="accordion-header"
                                id="headingThree"
                              >
                                <div className="accordion-button">
                                  <div className="d-flex align-items-center justify-content-between flex-fill">
                                    <h5>Registered Office Address</h5>
                                    <div className="d-flex">
                                      <Link
                                        to="#"
                                        className="btn btn-icon btn-sm"
                                        data-bs-toggle="modal"
                                        data-inert={true}
                                        data-bs-target="#office_address"
                                      >
                                        <i className="ti ti-edit" />
                                      </Link>
                                      <Link
                                        to="#"
                                        className="d-flex align-items-center collapsed collapse-arrow"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#primaryBorderThree"
                                        aria-expanded="false"
                                        aria-controls="primaryBorderThree"
                                      >
                                        <i className="ti ti-chevron-down fs-18" />
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                id="primaryBorderThree"
                                className="accordion-collapse collapse border-top"
                                aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <div className="row">
                                    <div className="col-md-4 mb-4">
                                      <span className="d-inline-flex align-items-center">
                                        Address
                                      </span>
                                      <h6 className=" align-items-center fw-medium mt-1">
                                        Hendry Peralt
                                      </h6>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                      <span className="d-inline-flex align-items-center">
                                        Post
                                      </span>
                                      <h6 className=" align-items-center fw-medium mt-1">
                                        Brother
                                      </h6>
                                    </div>
                                    <div className="col-md-4">
                                      <span className="d-inline-flex align-items-center">
                                       Taluka
                                      </span>
                                      <h6 className=" align-items-center fw-medium mt-1">
                                        25 May 2014
                                      </h6>
                                    </div>
                                    <div className="col-md-4 mb-4">
                                      <span className="d-inline-flex align-items-center">
                                        District
                                      </span>
                                      <h6 className=" align-items-center fw-medium mt-1">
                                        25 May 2014
                                      </h6>
                                    </div>
                                 
                              
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div
                            className="tab-pane fade"
                            id="address3"
                            role="tabpanel"
                            aria-labelledby="address-tab3"
                            tabIndex={0}
                        >
                            <div className="card">
                                <div className="card-header d-flex align-items-center justify-content-between">
                                    <h5>Bank Details    </h5>
                                    <Link
                                                                    to="#"
                                                                    className="btn btn-icon btn-sm"
                                                                    data-bs-toggle="modal" data-inert={true}
                                                                    data-bs-target="#bank_details"
                                                                >
                                                                    <i className="ti ti-edit" />
                                                                </Link>
                                </div>
                                <div className="card-body pb-0">
                                    <div className="row align-items-center">
                                       
                                        <div className="col-md-3">
                                            <div className="mb-3">
                                                <p className="mb-1">IFSC Code</p>
                                                <h6 className="fw-normal">harold@example.com</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="mb-3">
                                                <p className="mb-1">Account Holder Name </p>
                                                <h6 className="fw-normal">Indian</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="mb-3">
                                                <p className="mb-1">Bank Name</p>
                                                <h6 className="fw-normal">Christianity</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="mb-3">
                                                <p className="mb-1">Bank Account No</p>
                                                <h6 className="fw-normal">Christianity</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="mb-3">
                                                <p className="mb-1">Branch Name</p>
                                                <h6 className="fw-normal">Christianity</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="mb-3">
                                                <p className="mb-1">Branch Address </p>
                                                <h6 className="fw-normal">Christianity</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="mb-3">
                                                <p className="mb-1">Cancel Cheque</p>
                                                <h6 className="fw-normal">Christianity</h6>
                                            </div>
                                        </div>
                                     
                                    </div>
                                </div>
                            </div>
                        </div> */}
                  </div>
                </div>
              </div>
              {/* Candidate Details */}
            </div>
          </div>
        </div>
        {/* <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2014 - 2025 © SmartHR.</p>
          <p>
            Designed &amp; Developed By{" "}
            <Link to="#" className="text-primary">
              Dreams
            </Link>
          </p>
        </div> */}
      </div>
      {/* /Page Wrapper */}
      {/* Add current address */}
      <div className="modal fade" id="current_address">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Current Address</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Address <span className="text-danger"> *</span>
                      </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Post </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Taluka </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">District </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
               
                 
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-white border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="permanent_address">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Permanent Address</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Address <span className="text-danger"> *</span>
                      </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Post </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Taluka </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">District </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
               
                 
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-white border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="office_address">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Registered Office Address</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Address <span className="text-danger"> *</span>
                      </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Post </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Taluka </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">District </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
               
                 
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-white border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="personal_info">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Personal Details</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  {/* <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Email Id <span className="text-danger"> *</span>
                      </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Mobile No <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="tel"
                        name="mobile"
                        placeholder="Enter your mobile number"
                        className="form-control"
                      />
                    </div>
                  </div> */}
             

                  <div className="mb-3  col-md-12">
                    <label className="col-form-label ">
                      Applicant Signature
                      <span className="text-danger"> *</span>
                    </label>

                    <input className="form-control" type="file" />
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Pan Card No <span className="text-danger"> *</span>
                      </label>
                      <div className="mb-3 row">
                        <div className="col-md-4">
                          
                          <input type="text" className="form-control " />
                        </div>

                        <div className="col-md-8">
                          <input className="form-control" type="file" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Election Card No <span className="text-danger"> *</span>
                      </label>
                      <div className="mb-3 row">
                        <div className="col-md-4">
                         
                          <input type="text" className="form-control " />
                        </div>

                        <div className="col-md-8">
                          <input className="form-control" type="file" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-white border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="firm_info">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Firm Information</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Firm/Co-Operative Society Name{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Registration No. (If the applicant is a Co-operative
                        Society, Firm, Company, or other entity.){" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <div className="mb-3 row">
                        <div className="col-md-4">
                          {" "}
                          <input type="text" className="form-control " />
                        </div>

                        <div className="col-md-8">
                          <input className="form-control" type="file" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        GST No. (If the applicant is a Co-operative Society,
                        Firm, Company, or other entity.){" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <div className="mb-3 row">
                        <div className="col-md-4">
                          {" "}
                          <input type="text" className="form-control " />
                        </div>

                        <div className="col-md-8">
                          <input className="form-control" type="file" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Firm PAN No. (If the applicant is a Co-operative
                        Society, Firm, Company, or other entity.){" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <div className="mb-3 row">
                        <div className="col-md-4">
                          {" "}
                          <input type="text" className="form-control " />
                        </div>

                        <div className="col-md-8">
                          <input className="form-control" type="file" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        FPO (Farmer Producer Organization) Certificate (if
                        applicable) <span className="text-danger"> *</span>
                      </label>
                      <div className="mb-3 row">
                        <div className="col-md-4">
                          {" "}
                          <input type="text" className="form-control " />
                        </div>

                        <div className="col-md-8">
                          <input className="form-control" type="file" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-white border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="mobile_edit">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Mobile No</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowOtpInput(false)}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  
                  <div className="col-md-12 ">
                    <div className="mb-3">
                      <label className="form-label">
                       New Mobile No <span className="text-danger"> *</span>
                      </label>
                      <div className="row d-flex align-items-center justify-content-between ">
                        <div className="col-md-8">  <input
                        type="tel"
                        name="mobile"
                        placeholder="Enter your mobile number"
                        className="form-control mb-4 "
                      />
                     </div>
                     <div className="mb-4 col-md-4">
                          <button
                            // onClick={handleLogin}
                            onClick={handleSendOtp}
                            type="submit"
                            className="btn btn-success   align-item-center"
                            disabled={showOtpInput} 
                          >
                            Send OTP on Email
                          </button>
                        </div>
                      
                      </div>
                    
                        {showOtpInput && (<>
                          <div className="d-flex align-items-center justify-content-center mb-3">
                    
                             <InputOtp value={token} onChange={(e) => setTokens(e.value)} integerOnly />
                           </div>
                           <div className="mb-3 d-flex justify-content-center">
                           <p className="text-gray-9">
                             Didn't get the OTP?{" "}
                             <Link to="#"

                              className="text-primary">
                               Resend OTP
                             </Link>
                           </p>
                         </div>
                         <div className="d-flex align-items-center justify-content-center mb-3">
                         <button
                          
                            type="submit"
                            className="btn btn-success   align-item-center"
                           
                          >
                            Verify
                          </button>
                         </div>
                         </>
                           
                          )}
                    </div>
                  </div>
                

                </div>
              </div>
              <div className="modal-footer">
                {/* <button
                  type="button"
                  className="btn btn-white border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button> */}
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="email_edit">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Email Id</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowOtpInput2(false)}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  
                  <div className="col-md-12 ">
                    <div className="mb-3">
                      <label className="form-label">
                       New Email Id <span className="text-danger"> *</span>
                      </label>
                      <div className="row d-flex align-items-center justify-content-between ">
                        <div className="col-md-8">  <input
                        type="text"
                        name="email"
                        placeholder="Enter your email id"
                        className="form-control mb-4 "
                      />
                     </div>
                     <div className="mb-4 col-md-4">
                          <button
                            // onClick={handleLogin}
                            onClick={handleSendOtp2}
                            type="submit"
                            className="btn btn-success   align-item-center"
                            disabled={showOtpInput2} 
                          >
                            Send OTP on Mobile No
                          </button>
                        </div>
                      
                      </div>
                    
                        {showOtpInput2 && (<>
                          <div className="d-flex align-items-center justify-content-center mb-3">
                    
                             <InputOtp value={token} onChange={(e) => setTokens(e.value)} integerOnly />
                           </div>
                           <div className="mb-3 d-flex justify-content-center">
                           <p className="text-gray-9">
                             Didn't get the OTP?{" "}
                             <Link to="#"

                              className="text-primary">
                               Resend OTP
                             </Link>
                           </p>
                         </div>
                         <div className="d-flex align-items-center justify-content-center mb-3">
                         <button
                          
                            type="submit"
                            className="btn btn-success   align-item-center"
                           
                          >
                            Verify
                          </button>
                         </div>
                         </>
                           
                          )}
                    </div>
                  </div>
                

                </div>
              </div>
              <div className="modal-footer">
                {/* <button
                  type="button"
                  className="btn btn-white border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button> */}
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
